<script>
    import { langTextStore } from "../store/langtexts";
    import { fade } from "svelte/transition";
    import { outputVariableStore } from "../store/outputVariables.js";
    import WizardSummarySection from "./WizardSummarySection.svelte";
    import { factoryStore } from "../store/factories";
    import { createEventDispatcher, tick } from "svelte";
    import GenerateReport from "./GenerateReport.svelte";
    import { getContext } from "svelte";
    import DownloadIcon from "../Vectors/document.svelte";
    import Graph from "../SharedComponents/Graph/Graph.svelte";
    const dispatch = createEventDispatcher();
    const { open } = getContext("modal");

    let indexes = [0, 1, 2, 3, 4, 5, 6, 7];
    let labels = [
        $langTextStore.getText("legal-min-wage"),
        $langTextStore.getText("target-wage"),
    ];

    let colors = [
        "#F69A81",
        "#BC1A0D",
        "#771212",
        "#F67338",
        "#ED003C",
        "#3F5E63",
        "#628482",
        "#9BACAB",
        "#9FCFD6",
    ]; // same amount needed as labelsforparts

    let labelsForParts = [
        $langTextStore.getText("breakdown-material"),
        $langTextStore.getText("breakdown-polybag"),
        $langTextStore.getText("breakdown-labour"),
        $langTextStore.getText("breakdown-outsourced"),
        $langTextStore.getText("breakdown-logistics"),
        $langTextStore.getText("breakdown-tax-and-duties"),
        $langTextStore.getText("breakdown-overhead"),
        $langTextStore.getText("breakdown-margin-and-comission"),
    ];

    let percentages = [];
    percentages.push([]);
    percentages.push([]);
    let totals = [];
    totals.push(0);
    totals.push(0);
    let data2 = [
        { wage: "LMV", total: 0 },
        { wage: "target-wage", total: 0 },
    ];

    for (var i in indexes) {
        data2[0][i] = getValue(i, "base");
        totals[0] = totals[0] + getValue(i, "base");
        data2[1][i] = getValue(i, "target-wage");
        totals[1] = totals[1] + getValue(i, "target-wage");
    }
    for (var i in indexes) {
        percentages[0][i] = (getValue(i, "base") * 100) / totals[0];
        percentages[1][i] = (getValue(i, "target-wage") * 100) / totals[1];
    }

    function getValue(part, scenario) {
        var scenarioVars =
            $outputVariableStore.scenarioConfiguration.calculatedScenarios[
                scenario
            ];
        var ret = 0;
        switch (part + "") {
            case "0":
                ret =
                    scenarioVars["ProductFabricDisplay"] +
                    scenarioVars["ProductAccessoriesDisplay"];
                break;
            case "1":
                ret = scenarioVars["ProductPolybagDisplay"];
                break;

            case "2":
                ret = scenarioVars["ProductTotalLabourMinWageDisplay"];
                break;

            case "3":
                ret = scenarioVars["ProductOutsourcedDisplay"];
                break;

            case "4":
                ret = scenarioVars["ProductLogisticsDisplay"];
                break;

            case "5":
                ret = scenarioVars["ProductTaxDisplay"];
                break;

            case "6":
                ret = scenarioVars["ProductOverheadDisplay"];
                break;

            case "7":
                ret = scenarioVars["ProductMarkupMinWageDisplay"];
                break;

            default:
                throw "unknown part";
        }

        if (ret == undefined || ret == null || isNaN(ret)) ret = 0;
        return ret;
    }

    function lockCalculation() {
        factoryStore.setLocked(true);
        dispatch("change", null);
    }
    function unLockCalculation() {
        factoryStore.setLocked(false);
        dispatch("change", null);
    }

    function showReportModal() {
        open(
            GenerateReport,

            { closeButton: false }
        );
    }

    let pdfSheetNum = 1;
</script>

<div class=" col-6 section vh-90">
    <div class="section__container h-100 pane  position-relative">
        <div class="row g-0">
            <!-- <div id="chart" bind:this={chartItem} /> -->
            <div class="col-12 position-relative">
                <h2 class="highlight">
                    {$langTextStore.getText("general-header-summary-report")}
                </h2>

                <WizardSummarySection hideHeader={true} isFactory={false} />

                <hr class="mb-3 mt-5" />
                {$langTextStore.getText("general-footer-text")}
            </div>
        </div>
    </div>
</div>
<div class="bg-white col-3 section reports" style="max-height:100%">
    <Graph bind:data={data2} bind:percentages bind:labelsForParts />
</div>
<div class="col-3 section reports">
    <div class="section__container pane h-100">
        <div class="mb-5">
            <h2 class="highlight pb-4">Legends</h2>

            {#each indexes as theindex}
                <div class="pb-4">
                    <span
                        class="reports-legend-item me-2"
                        style="background-color:{colors[theindex]}">&nbsp;</span
                    >
                    {labelsForParts[theindex]}<br />
                </div>
            {/each}
        </div>
        <div
            class="btn btn--open  mt-3 mb-4 font-weight-bold c-pointer "
            on:click={showReportModal}
        >
            <DownloadIcon />&nbsp;{$langTextStore.getText(
                "general-label-generate-report"
            )}
        </div>
        {#if !$factoryStore.currentCalculator.isLocked}
            <button class="btn btn-black  w-100" on:click={lockCalculation}
                >{$langTextStore.getText(
                    "general-label-lock-calculation"
                )}</button
            >
        {:else}
            <button class="btn btn-gray w-100" on:click={unLockCalculation}
                >{$langTextStore.getText(
                    "general-label-unlock-calculation"
                )}</button
            >
        {/if}
    </div>
</div>

<!-- <style>
    :global(.chart-legend) {
        display: none;
    }
    .flexmiddle {
        display: flex;
        align-items: center;
    }

    :global(.bi-file-earmark-text-fill) {
        margin-bottom: -3px;
        margin-right: 5px;
    }
</style> -->
